import(/* webpackMode: "eager" */ "/app/node_modules/@blitzjs/next/dist/chunks/index-browser.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["BlitzProvider"] */ "/app/node_modules/@blitzjs/next/dist/provider.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@blitzjs/rpc/dist/chunks/utils.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Hydrate","QueryClientProvider","invoke","invokeWithCtx","useQueryErrorResetBoundary"] */ "/app/node_modules/@blitzjs/rpc/dist/index-browser.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["BlitzProvider","BlitzRpcPlugin","useInfiniteQuery","useMutation","usePaginatedQuery","useQuery"] */ "/app/node_modules/@blitzjs/rpc/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/bibi-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/infravelo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/nudafa-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/osm-parkraum-logo-2025.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/radinfra-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/trto-logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/assets/ueberlingen-logo.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["DevMiddlewareHostnameWorkaround"] */ "/app/src/app/regionen/[regionSlug]/_components/DevMiddlewareHostnameWorkaround.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapInterface"] */ "/app/src/app/regionen/[regionSlug]/_components/MapInterface.tsx");
